import React, { useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.svg";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdClose } from "react-icons/io";

export default function Navbar() {

  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const toggleMenu = () => setIsOpen(!isOpen);

  const closeMenu = () => {
    setIsOpen(false);
    window.scrollTo(0, 0);  // Scroll to top when navigating to home
  
  }
 

  const  moveToHome = () => {
    navigate('/');
    window.scrollTo(0, 0);  // Scroll to top when navigating to home
  }
  const handleLinkClick = () => {
    window.scrollTo(0, 0);  // Scroll to top whenever any link is clicked
  };

  return (
    <>
      <nav className="bg-white py-2 border-b border-gray-300 overflow-hidden px-1 lg:px-4 sticky top-0 z-10 shadow-lg">
        <div className="lg:px-8 flex justify-between items-center">
          
          <div className=" flex items-center gap-1 cursor-pointer" onClick={()=>moveToHome()}>
            <img src={logo} alt="Logo" title="Alfred" className='w-[70px] h-[70px]' />
             <h1 className='text-3xl'>Alfred</h1>
          </div>

          {/* Hide on small/medium devices, show on large */}
          <div className="hidden lg:flex space-x-14 mx-auto">
            <Link to="" className="text-black hover:text-gray-600 font-semibold" onClick={()=>handleLinkClick()}>Home</Link>
            <Link to="/products" className="text-black hover:text-gray-600 font-semibold" onClick={()=>handleLinkClick()}>Products</Link>
            <Link to="/demo" className="text-black hover:text-gray-600 font-semibold" onClick={()=>handleLinkClick()}>Demo</Link>
            <Link to="/blogs" className="text-black hover:text-gray-600 font-semibold" onClick={()=>handleLinkClick()}>Blogs</Link>
            <Link to="/contact" className="text-black hover:text-gray-600 font-semibold" onClick={()=>handleLinkClick()}>Contact</Link>
            {/* <Link to="/about" className="text-black hover:text-gray-600 font-semibold">About</Link> */}
          </div>

          {/* Show on small/medium devices, hide on large */}
          <div className="lg:hidden cursor-pointer pe-2">
            {isOpen ? (
              <IoMdClose size={28} color='grey' onClick={toggleMenu} />
            ) : (
              <GiHamburgerMenu size={28} color='grey' onClick={toggleMenu} />
            )}
          </div>
        </div>
      </nav>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="fixed  z-20" onClick={closeMenu}></div>
      )}
      <div
        className={`fixed flex flex-col  w-full bg-gray-200 p-5 rounded-xl gap-8 text-center   
          
          transform transition-transform duration-300 ease-in-out z-30 
          lg:hidden
          ${
          isOpen ? "translate-x-0" : "-translate-x-full"
        }`
      }

        style={{
          opacity : "0.94"
        }}
 
      >
        <Link to="" className="text-black hover:text-gray-600 font-semibold block" onClick={closeMenu}>Home</Link>
        <Link to="/products" className="text-black hover:text-gray-600 font-semibold block" onClick={closeMenu}>Products</Link>
        <Link to="/demo" className="text-black hover:text-gray-600 font-semibold block" onClick={closeMenu}>Demo</Link>
        <Link to="/blogs" className="text-black hover:text-gray-600 font-semibold block" onClick={closeMenu}>Blogs</Link>
        <Link to="/contact" className="text-black hover:text-gray-600 font-semibold block" onClick={closeMenu}>Contact</Link>
        {/* <Link to="/about" className="text-black hover:text-gray-600 font-semibold block" onClick={closeMenu}>About</Link> */}
      </div>
    </>
  );
}